<template>
	<div class="v-container">
		<div id="pano">
			<noscript>
				<div>Javascript not activated</div>
			</noscript>
		</div>
		<div v-if="isCompareView" class="compare-box">
			<div id="pano2" class="compare-pano" :style="{opacity:compareOpacity/100}"></div>
			<i class="close iconfont icon-close" @click="actionHideCompareView"></i>
			<div class="opacity-slider">
				<div class="opacity-slider-row">
					<div class="label">透明度：</div>
					<el-slider class="slider-box" v-model="compareOpacity" :format-tooltip="()=>compareOpacity"></el-slider>
				</div>
				<div>(请拖动外侧场景调整，此场景为第一次拍摄场景)</div>
			</div>
		</div>
		<div v-if="isTranslating" class="translating-mask">转码中...</div>
		<page-header />
		<scene-bar />
	</div>
</template>

<script>
	import {mapState,mapActions} from 'vuex';
	import sceneBar from "./components/scene-bar";
	import pageHeader from './components/page-header'


	export default {
		components: {
			sceneBar,
			pageHeader
		},

		data() {
			return {
				compareOpacity: 100
			}
		},

		computed: {
			...mapState('tour', ['isTranslating', 'isCompareView']),
		},

		methods:{
			...mapActions('tour',{
				actionHideCompareView: "hideCompareView",
			})
		}

	};
</script>

<style scoped>
	#pano {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
	}

	.v-container {
		overflow: hidden;
	}

	.translating-mask {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		background: #666;
		color: #fff;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 18px;
	}

	.compare-box {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 400px;
		height: 70%;
		overflow: hidden;
		border: 1px solid #fff;
	}



	.compare-pano {
		position: absolute;
		top: 50%;
		left: 50%;
		width: 100vw;
		height: 100vh;
		transform: translate(-50%, -50%);
		opacity: 1;
	}

	.compare-box .close{
		position: absolute;
		top:0;
		right: 0;
		width: 30px;
		height: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		background: rgba(0, 0, 0, 0.7);
		color: #fff;
	}

	.opacity-slider {
		position: absolute;
		width: 100%;
		bottom: 0;
		height: 70px;
		color: #fff;
		background: rgba(0, 0, 0, 0.7);
		padding: 0 20px;
		box-sizing: border-box;
	}

	.opacity-slider-row{
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.slider-box {
		flex: 1;
	}


</style>
